export function isSettingField(obj) {
  return obj && obj.isSettingField;
}